import * as XLSX from 'xlsx';

// 导出文件
export const exportExcel = (datasource, columns, filename = 'Papfile.xlsx') => {
  // 数据转换
  const exportData = datasource.map((item) => {
    const row = {};
    columns.forEach((col) => {
      row[col.label] = item[col.prop] || '';
    });
    return row;
  });

  // 创建工作簿和工作表
  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  XLSX.writeFile(workbook, filename);
};

// 调用导出函数
